import { GreetingProtectionTypeEnum } from "../types";
import GreetingProtection from "./GreetingProtection";

export default class NoneGreetingProtection extends GreetingProtection {
  type: GreetingProtectionTypeEnum = GreetingProtectionTypeEnum.None

  accept_join_requests = false
}
